import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store/index';
import ElementUI from 'element-ui';
import locale from 'element-ui/lib/locale/lang/ko';
import './lib/element-ui/custom-theme/index.css';
import './lib/dashkit/scss/theme.scss';
import './scss/element-custom/element-custom.scss';
import './scss/icon.scss';
import './scss/common.scss';
import Vuebar from 'vuebar';
import { TokenStorage } from './utils/token-storage';
import { LocalStore } from './utils/local-store';
import { addOptimizedResizerEventListener } from './utils/optimized-resize';
import { format } from 'date-fns';
import { Popup, Actionsheet, Collapse, CollapseItem } from 'vant';
import 'vant/lib/index.css';
import { alert, confirm } from './utils/message-box';
import dateFns from 'date-fns';
import { initAllThirdPartyApps } from './utils/third-party-app';

Vue.use(Vuebar);
Vue.use(Popup);
Vue.use(Actionsheet);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(ElementUI, { locale });
Vue.config.productionTip = false;

Vue.prototype.$tokenStorage = new TokenStorage();
Vue.prototype.$localStore = new LocalStore();
Vue.prototype.$formatDate = format;

Vue.prototype.$alert = alert;
Vue.prototype.$confirm = confirm;
Vue.prototype.$dateFns = dateFns;

Date.prototype.toDateFormat = function() {
  return dateFns.format(this, 'YYYY-MM-DD');
};

addOptimizedResizerEventListener();
initAllThirdPartyApps();

export const vm = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
